import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function CtaButton({
  href,
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center rounded-xl border-b-4 border-amarillo-dark bg-amarillo px-4 py-3 text-center text-sm font-extrabold uppercase tracking-wide text-navy shadow-[0_0_0_3px_rgb(7_29_73/0.12)] transition-[filter,transform] duration-150 ease-soft hover:brightness-105 active:translate-y-px active:scale-[0.99] sm:text-lg ${className}`} data-id="element-160" data-mp="1vvhde7s5cuuj">
      {children}
    </a>;
}